export default __webpack_public_path__ + "static/media/torinranta_1.bf841f4e.jpg";